<template>
  <div class="main">
    <div class="footer relative_parent">
      <div class="footer_k">
        <div class="left">
          <a
            target="view_window"
            style="display: inline-block"
            href="http://bszs.conac.cn/sitename?method=show&id=28A24350E2216A7EE053022819AC944C"
          >
            <img class="img1" src="../assets/image/logo/blue.png" alt />
          </a>
          <p class="p2">
            舟山博物馆&nbsp;主办&nbsp;
            <a target="view_window" href="https://beian.miit.gov.cn/"
              >浙ICP备06044333号-2</a
            >
          </p>
        </div>
        <div class="right">
          <p class="p2">
            技术支持:&nbsp;杭州银美科技有限公司
            <a
              target="_blank"
              href="https://uweb.umeng.com/v1/login.php?siteid=1252956294"
              title="站长统计"
            >
              <img
                border="0"
                hspace="0"
                vspace="0"
                src="https://icon.cnzz.com/img/pic.gif"
              />
            </a>
          </p>
          <div @mouseover="enter" @mouseout="out">
            <div>
              <img class="img2" src="../assets/image/foot2.png" alt />
            </div>

            <div class="out_k" :style="h">
              <div class="foot_nav">
                <div class="foot_nav1">
                  <ul>
                    <li
                      v-for="(item, index) of ul1"
                      :key="index"
                      @click="gaishu(index)"
                    >
                      {{ item.name }}
                    </li>
                  </ul>
                  <ul>
                    <li
                      v-for="(item, index) of ul2"
                      :key="index"
                      @click="zixun(index)"
                    >
                      {{ item.name }}
                    </li>
                  </ul>
                  <ul>
                    <li
                      v-for="(item, index) of ul3"
                      :key="index"
                      @click="zhanlan(index)"
                    >
                      {{ item.name }}
                    </li>
                  </ul>

                  <ul>
                    <li
                      @click="huodongyugao(index)"
                      v-for="(item, index) of ul4"
                      :key="index"
                    >
                      {{ item.name }}
                    </li>
                  </ul>
                  <ul>
                    <li @click="diancang()">典藏</li>
                  </ul>
                  <ul>
                    <li
                      @click="zhuanlan(index)"
                      v-for="(item, index) of ul5"
                      :key="index"
                    >
                      {{ item.name }}
                    </li>
                  </ul>
                  <ul>
                    <li
                      @click="xueshu(index)"
                      v-for="(item, index) of ul6"
                      :key="index"
                    >
                      {{ item.name }}
                    </li>
                  </ul>
                  <ul>
                    <li
                      @click="wenchuang(index)"
                      v-for="(item, index) of ul7"
                      :key="index"
                    >
                      {{ item.name }}
                    </li>
                  </ul>
                </div>
                <div class="foot_nav2">
                  <p>友情链接</p>
                  <div>
                    <select
                      name
                      id
                      class="bg_select"
                      v-model="couponSelected"
                      @change="getCouponSelected"
                    >
                      <option
                        :value="item.name"
                        v-for="(item, index) of couponList"
                        :key="index"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class="select_parent">
                    <select name id>
                      <option value>--市政府网站--</option>
                    </select>
                    <div class="bg_select"></div>
                  </div>
                  <div class="select_parent">
                    <select name id @change="getCouponSelected">
                      v-model="couponSelecteds"

                      <option value="--文献网站--">--文献网站--</option>
                      <option value="--知网博物馆业务平台--"
                        >--知网博物馆业务平台--</option
                      >
                      <option value="--超星发现文博--">--超星发现文博--</option>
                    </select>
                    <div class="bg_select"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ul1: [
        { name: "概述" },
        { name: "舟博简介" },
        { name: "领导介绍" },
        { name: "部门设置" }
      ],
      ul2: [
        { name: "资讯" },
        { name: "新闻资讯" },
        { name: "活动公告" },
        { name: "馆务公开" },
        { name: "文博动态" }
        // { name: "大事记" },
      ],
      ul3: [
        { name: "展览" },
        { name: "基本陈列" },
        { name: "临时展览" },
        { name: "网上展厅" },
        { name: "外推展览" }
      ],
      // ul4: [
      //   { name: "活动" },
      //   { name: "活动预告" },
      //   { name: "文博课堂" },
      //   { name: "文博讲座" },
      //   { name: "青少年活动" }
      // ],

      ul5: [
        { name: "专栏" },
        { name: "志愿者之家" },
        { name: "制度建设" },
        { name: "宣教活动" },
        { name: "践行社会主义核心价值观" }
      ],

      ul6: [
        { name: "学术" },
        { name: "学术成果" },
        { name: "课题研究" },
        { name: "读书分享" }
      ],
      ul7: [{ name: "文创" }],
      h: {
        height: 0
      },
      couponList: [
        {
          name: "--博物馆网站--"
        },
        {
          name: "--中国国家博物馆--"
        },
        {
          name: "--浙江省博物馆--"
        }
      ],
      couponSelected: "--博物馆网站--",
      couponSelecteds: "--博物馆网站--"
    };
  },

  methods: {
    gaishu(index) {
      if (index == 1 || index == 0) {
        this.orderId = 1;
      } else if (index == 2) {
        this.orderId = 2;
      } else if (index == 3) {
        this.orderId = 3;
      }
      this.$router
        .push({
          path: "/lindaojieshao/lindaojieshao2/:id",
          query: { orderId: this.orderId }
        })
        .catch(err => {
          err;
        });
    },

    zixun(i) {
      if (i == 0 || i == 1 || i == 2 || i == 3 || i == 4) {
        if (i == 1 || i == 0) {
          this.orderId = "新闻资讯";
          this.sort = "xinwenzixun";
        } else if (i == 2) {
          this.orderId = "活动公告";
          this.sort = "huodonggonggao";
        } else if (i == 3) {
          this.orderId = "馆务公开";
          this.sort = "guanwugongkai";
        } else if (i == 4) {
          this.orderId = "文博动态";
          this.sort = "wenbodongtai";
        }
        this.$router
          .push({
            path: "/guanwugongkai/guanwugongkai2/:id",
            query: { orderId: this.orderId, zixun: this.sort }
          })
          .catch(err => {
            err;
          });
      }
      // if (i == 5) {
      //   this.$router
      //     .push({
      //       path: "/guanwugongkai/dashiji/:id",
      //       query: { orderId: "大事记" },
      //     })
      //     .catch((err) => {
      //       err;
      //     });
      // }
    },
    zhanlan(i) {
      if (i == 1 || i == 0) {
        this.$router
          .push({
            path: "/linzhan/basez/:id",
            query: { orderId: "基本陈列" }
          })
          .catch(err => {
            err;
          });
      } else if (i == 2) {
        let time = new Date();
        let year = time.getFullYear();

        this.$router
          .push({
            path: "/linzhan/line/year1/:id",
            query: { orderId: "临时展览", lookUrl: year, title: "timeline" }
          })
          .catch(err => {
            err;
          });
      } else if (i == 3) {
        this.$router
          .push({
            path: "/linzhan/year/:id",
            query: { orderId: "网上展厅" }
          })
          .catch(err => {
            err;
          });
      } else if (i == 4) {
        let time = new Date();
        let year = time.getFullYear();
        this.$router
          .push({
            path: "/linzhan/line/year1/:id",
            query: {
              orderId: "外推展览",
              lookUrl: year,
              title: "extrapolation"
            }
          })
          .catch(err => {
            err;
          });
      }
    },
    huodongyugao(i) {
      if (i == 1 || i == 0) {
        this.$router
          .push({
            path: "/huodongyugao/huodongyugao2/:id",
            query: { orderId: "活动预告" }
          })
          .catch(err => {
            err;
          });
      } else if (i == 3) {
        this.$router
          .push({
            path: "/huodongyugao/wenbojiangzuo/:id",
            query: { orderId: "文博讲座" }
          })
          .catch(err => {
            err;
          });
      }
      if (i == 2 || i == 4) {
        if (i == 2) {
          this.orderId = "文博课堂";
          this.sort = "wenboketang";
        } else if (i == 4) {
          this.orderId = "青少年活动";
          this.sort = "qingshaonianhuodong";
        }
        this.$router
          .push({
            path: "/huodongyugao/wenboketang/:id",
            query: { orderId: this.orderId, ketang: this.sort }
          })
          .catch(err => {
            err;
          });
      }
    },

    diancang() {
      this.$router.push(`/cangpinxinshang`).catch(err => {
        err;
      });
    },
    zhuanlan(i) {
      if (i == 0 || i == 1) {
        this.$router
          .push({
            path: "/zhidujianshe/zhiyuanzhezhijia/:id",
            query: { orderId: "志愿者之家" }
          })
          .catch(err => {
            err;
          });
      }
      if (i == 2 || i == 3 || i == 4) {
        if (i == 2) {
          this.orderId = "制度建设";
          this.sort = "zhidujianshe";
        } else if (i == 3) {
          this.orderId = "宣教活动";
          this.sort = "xuanjiaohuodong";
        } else if (i == 4) {
          this.orderId = "践行社会主义核心价值观";
          this.sort = "jxshzyhxjzg";
        }
        this.$router
          .push({
            path: "/zhidujianshe/zhidujianshe2/:id",
            query: { orderId: this.orderId, zhuanlan: this.sort, num: i }
          })
          .catch(err => {
            err;
          });
      }
    },
    xueshu(i) {
      if (i == 1 || i == 0) {
        this.sort = "xueshuchengguo";
        this.orderId = "学术成果";
      } else if (i == 2) {
        this.sort = "ketiyanjiu";
        this.orderId = "课题研究";
      } else if (i == 3) {
        this.sort = "dushufenxiang";
        this.orderId = "读书分享";
      }
      this.$router
        .push({
          path: "/ketiyanjiu/ketiyanjiu2/:id",
          query: { orderId: this.orderId, xueshu: this.sort }
        })
        .catch(err => {
          err;
        });
    },
    wenchuang() {
      this.$router
        .push({
          path: "/wenchuang",
          query: { orderId: 1 }
        })
        .catch(err => {
          err;
        });
    },
    getCouponSelected(index) {
      //获取选中的优惠券

      if (index.target.value == "--博物馆网站--") {
      } else if (index.target.value == "--中国国家博物馆--") {
        console.log(1);
        window.open("http://www.chnmuseum.cn/");
        // window.location.href = ;
      } else if (index.target.value == "--浙江省博物馆--") {
        window.open("http://www.zhejiangmuseum.com");
        // window.location.href = "";
      } else if (index.target.value == "--知网博物馆业务平台--") {
        window.open("https://bwg.cnki.net");
        // window.location.href = "";
      } else if (index.target.value == "--超星发现文博--") {
        window.open("http://faxianwenbo.superlib.net/public/index?appId=1000");
        // window.location.href = "";
      }
    },

    enter() {
      this.h.height = "343px";
    },
    out() {
      this.h.height = 0;
    }
  }
};
</script>
<style scoped>
a {
  color: #ffffff;
  text-decoration: none;
}
p,
ul,
li {
  margin: 0px;
  padding: 0px;
  cursor: pointer;
}

.zl:hover {
}
/* ========== */
.footer {
  height: 50px;
  width: 100%;
  background: rgb(0, 0, 0);
  display: flex;
  color: white;
  /* position:absolute; */
  /* bottom:0px; */
}
.footer_k {
  width: 50%;
  display: flex;
  margin: auto;
  justify-content: space-around;
}
.footer .left {
  display: flex;
}
.footer .right {
  display: flex;
  align-items: center;
}
.footer .img1 {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.footer .img2 {
  height: 10px;
}
.footer .p2 {
  margin-right: 10px;
  width: 335px;
  font-size: 16px;
}
.main {
  /* height: calc(100vh - 170px); */
  position: absolute;
  width: 100%;
  bottom: -50px;
}

/* d底部导航 */
ul,
p,
li {
  padding: 0px;
  margin: 0px;
}
li {
  list-style: none;
}
.relative_parent {
  position: relative;
}
.out_k {
  background: black;
  opacity: 0.8;

  width: 100%;
  box-sizing: border-box;
  height: 363px;
  position: absolute;
  bottom: 50px;
  left: 0px;
  transition: height 2s linear;
  z-index: 999;
  overflow: hidden;
}
.out_k .foot_nav {
  padding-top: 60px;
  width: 55%;
  height: 70%;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.out_k .foot_nav1 {
  width: 100%;
  display: flex;
  color: white;
  justify-content: space-between;
}

.out_k .foot_nav1 li {
  line-height: 35px;
  font-size: 16px;
  color: white;
}
.out_k .foot_nav2 {
  display: flex;
  justify-content: space-evenly;
}
/* .select_parent {
  box-sizing: border-box;
  width: 140px;
display:flex;
position: relative;
  overflow: hidden;
  background-color: #eeeeee;
} */
.out_k select {
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  border: solid 1px #000;
  padding: 3px 20px;
  padding-right: 40px;
  border-radius: 3px;
  font-size: 18px;
  cursor: pointer;
  background: url("../assets/image/select.png") no-repeat scroll right center
    transparent;
  background-color: white;
}
.out_k select option {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/foot3.vue